import tempMeeApi from '../../../apis/tempMee';

/**
 * Fetches onsite interview list from the API
 *
 * @param {import('../types/OnsiteInterviewList.parameters').IGetOnsiteInterviewListPayload} payload - Request payload
 * @returns {Promise<import('../types/OnsiteInterviewList.api').IGetOnsiteInterviewListApiResponse>} Onsite interview list API response
 */
export const getOnsiteInterviewList = async ({
  postingId,
  page,
  limit,
  orderBy,
  orderDirection,
  status,
  professionalId,
}) => {
  const response = await tempMeeApi.get(`/admin/postings/${postingId}/onsite-interviews`, {
    params: {
      page,
      limit,
      orderBy: orderBy || undefined,
      orderDirection: orderDirection || undefined,
      status: status || undefined,
      professionalId: professionalId || undefined,
    },
  });
  return response.data;
};
